import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ChatApi {
    private readonly baseUrl = `${environment.apiBaseUrl.replace(/\/$/, '')}/chat`;

    // Streams a message using the Fetch API (native SSE via ReadableStream)
    // Returns an AsyncGenerator that yields text chunks as they arrive
    async *streamUserMessage(
        question: string,
        sessionId: string | null,
        csrfToken: string,
    ): AsyncGenerator<{ text?: string; done?: boolean; sessionId?: string; error?: string }> {
        // Auth rides the httpOnly user session cookie (credentials: 'include'); the
        // double-submit CSRF token is echoed in the `x-csrf-token` header. This
        // mirrors the HttpClient interceptor for the streaming Fetch path.
        const response = await fetch(`${this.baseUrl}/user/message`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                ...(csrfToken ? { 'x-csrf-token': csrfToken } : {}),
            },
            body: JSON.stringify({ question, ...(sessionId ? { sessionId } : {}) }),
        });

        if (!response.ok || !response.body) {
            yield { error: 'Failed to connect to chat service.' };
            return;
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';

        while (true) {
            const { done, value } = await reader.read();
            if (done) break;

            buffer += decoder.decode(value, { stream: true });
            const lines = buffer.split('\n');
            buffer = lines.pop() ?? '';

            for (const line of lines) {
                if (line.startsWith('data: ')) {
                    try {
                        const parsed = JSON.parse(line.slice(6));
                        yield parsed;
                    } catch {
                        // skip malformed chunks
                    }
                }
            }
        }
    }
}
